import { Component, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router } from "@angular/router";

import { LoginService } from './../login.service';
import { GeoServices } from '../../../services/geo.service';
import { ConfigService } from '../../../services/config.service';
import { FormComponentI } from '../../../shared/interfaces/form-component-i.interface';
import { InternalStateEvent } from '../../../shared/models/internal-state-event';
import { TranslateService } from 'ng2-translate';
import { StateMiscArgument } from 'nm-socle-application/app/shared/models/customer-config';
import { TemplateInitService } from 'nm-socle-application/app/shared/services/template-init.service';
import { TemplateCurrentState } from 'nm-socle-application/app/shared/models/template-current-state';
import { FormControl } from '@angular/forms';
import {AbstractComponent} from 'nm-socle-application/app/shared/models/abstract-component';
import {Observable} from 'rxjs';

@Component({
    selector: 'login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    changeDetection:ChangeDetectionStrategy.OnPush,
})
export class LoginFormComponent extends AbstractComponent implements FormComponentI {
    public login: string;
    public loginInp = new FormControl();
    public loginValid:boolean = false;

    public psw: string;
    public pswInp = new FormControl();
    public pswValid:boolean = false;

    public customerId: number = null;
    public customerIdDefault: number = undefined;

    public isLoginTry:boolean = false;

    public requestPasswordError: string;

    public passswordInput = {
        'icon':  'fa-eye-slash',
        'inputType': 'password',
        'tooltip': 'login.password.hidden'
    };

    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    @Output() public internalStateEvent: EventEmitter<InternalStateEvent> = new EventEmitter();
    @Input() public misc:StateMiscArgument[] = [];

    constructor(
        public loginService: LoginService,
        public geoServices: GeoServices,
        protected _configService: ConfigService,
        protected _router: Router,
        protected _translateService: TranslateService,
        protected _cd:ChangeDetectorRef,
        protected _templateInitService: TemplateInitService,
    ) {
        super(_cd);
    }

    public ngOnInit() {
        super.ngOnInit();

        this.customerIdDefault = this._configService.get('customerIdDefault') ? parseInt(this._configService.get('customerIdDefault')) : undefined;
        this.customerId = this._configService.get('customerId');

        if (this.loginService.isUserLogged()) {
            this.closeEvent.emit('loginOk');
            return ;
        }

        this.addSub = this.loginInp.statusChanges.subscribe(evt => {
            this.loginValid = this.loginInp.valid;

            this.markForCheck();
        });

        this.addSub = this.pswInp.statusChanges.subscribe(evt => {
            this.pswValid = this.pswInp.valid;

            this.markForCheck();
        });

        this.markForCheck();
    }

    public submitReLogin() {
        this.submitLogin(true);
    }

    public submitLogin(reLogin?: boolean) {
        this.isLoginTry = true;

        this.markForCheck();

        this.addSub = this.loginService.login(this.login, this.psw, this.customerId, reLogin).catch(errorMessage => {
            this.isLoginTry = false;

            this.markForCheck();

            return Observable.throw(errorMessage);
        }).subscribe(
            user => {
                this.isLoginTry = false;

                this.closeEvent.emit('loginOk');
            }
        );

        this.markForCheck();
    }

    public logout() {
        this.loginService.logout();
        this._router.navigate([''], { queryParams: { customerId: this._configService.get('customerId') } }).then( () => window.location.reload());
    }

    // TODO : rendre paramétrable
    public toggleLostPasswordForm() {
        let target:string = 'loginPassLost';
        let speTarget = this.getFromMisc('target');

        if(speTarget != undefined) {
            target = speTarget;
        }
        this._templateInitService.setCurrentState(new TemplateCurrentState({state: target}))
    }

    public getFromMisc(name:string):any {
        let res:any;

        for(let curMisc of this.misc) {
            if(curMisc.name == name) {
                res = curMisc.value;
                break;
            }
        }

        return res;
    }

    public togglePassswordInputType() {
        if (this.passswordInput.inputType == 'password') {
            this.passswordInput = {
                'icon':  'fa-eye',
                'inputType': 'text',
                'tooltip': 'login.password.displayed'
            };
        }
        else {
            this.passswordInput = {
                'icon':  'fa-eye-slash',
                'inputType': 'password',
                'tooltip': 'login.password.hidden'
            };
        }
        this._cd.markForCheck();  
    }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/login/login-form/login-form.component.ts